import { HUB_MENU_PRELOAD_IMAGE_PATHS } from '../config/welcomeAssets';
import { preloadImage } from '../hooks/mediaPreload';

/**
 * Warm all hub menu still images (backgrounds, painted panels, nav buttons).
 * Safe to call multiple times — preloadImage dedupes by resolved URL.
 * @param {readonly string[]} [paths]
 * @returns {Promise<PromiseSettledResult<unknown>[]>}
 */
export async function preloadHubMenuImages(paths = HUB_MENU_PRELOAD_IMAGE_PATHS) {
  if (!Array.isArray(paths) || paths.length === 0) {
    throw new Error('preloadHubMenuImages: paths must be a non-empty array');
  }

  const results = await Promise.allSettled(paths.map((path) => preloadImage(path)));
  const failed = results.filter((result) => result.status === 'rejected');
  if (failed.length > 0) {
    console.warn(
      `Hub menu image preload: ${failed.length}/${paths.length} failed`,
      failed.map((result) => result.reason)
    );
  }
  return results;
}
